import React, { useCallback } from 'react'

import { useSelector } from 'react-redux'
import { Menu } from 'antd'
import { faBusinessTime } from '@fortawesome/pro-solid-svg-icons'

import IconLabel, { FontSizes } from '../../../../Components/icons/IconLabel'
import RequestStateCheckbox from './RequestStateCheckbox'
import { StateTypes } from '../../../../utils/entities/internshipRequest'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'

export const getActiveFiltersCount = (filters) => {
  const filtersState = filters ?? {}
  let count = 0

  if (Array.isArray(filtersState.states) && filtersState.states.length > 0) {
    count += 1
  }

  return count
}

const InternshipRequestFilters = ({ filters, onFiltersChange }) => {
  const t = useSelector(selectTranslate)

  const handleFilterChange = useCallback(value => {
    let newStates = [...value]

    if (value.includes(StateTypes.OPEN.key)) {
      newStates = newStates.filter(v => v !== StateTypes.OPEN.key)
      newStates = newStates.concat(StateTypes.OPEN.values)
    }

    if (value.includes(StateTypes.CLOSED.key)) {
      newStates = newStates.filter(v => v !== StateTypes.CLOSED.key)
      newStates = newStates.concat(StateTypes.CLOSED.values)
    }

    onFiltersChange({ ...filters, states: newStates })
  }, [onFiltersChange, filters])

  return (
    <Menu inlineIndent={0}>
      <div className='h-spacing pdt-8' />
      <Menu.ItemGroup title={<IconLabel fontSize={FontSizes.SMALL} padding={0} icon={faBusinessTime} text={t('common.state')} />}>
        <RequestStateCheckbox value={filters?.states ?? []} onCheck={handleFilterChange} />
      </Menu.ItemGroup>
    </Menu>
  )
}

export default InternshipRequestFilters
